import React from 'react';
import { Badge as BaseBadge } from './badge-base';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'sm' | 'md';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'primary',
  size = 'sm',
  className = '',
}) => {
  return (
    <BaseBadge variant={variant} size={size} className={className}>
      {children}
    </BaseBadge>
  );
};

export default Badge;
